<template>
  <v-layout 
    v-if="enterprise && enterprise.TotemMainMenuType && enterprise.TotemMainMenuType==='logo'"
    wrap 
    style="height: 180px;fontFamily: MontserratRegular, sans-serif"
    :style="{
      backgroundColor: bgColor,
      color: textColor,
    }"
  >
    <v-flex
      xs2
      style="padding-top:25px;"
      @click="handleReload"
    >
      <img 
        v-if="enterprise.Logo" 
        :src="enterprise.Logo"
        style="width: 320px;max-height:145px;"
      />
    </v-flex>
    <v-flex 
      xs7 
      style="background-color:red;"
    >
      <v-layout wrap>
    <v-flex 
      xs2 
      v-for="(item, index) of menus"
      @click="handleClick(item.action, item, index)"
      :style="{ backgroundColor: bgSecondaryColor }"
      :class="enterprise.TotemMainMenuType === 'between' ? 'menu-item-between' : noShadow ? 'menu-item-no-shadow' : 'menu-item'"
      style="height:180px;"
    >
      <center 
        style="height:40px"
      >
        <v-icon dark x-large
        v-if="activeMenu === item.action"
        >
          mdi-menu-up
        </v-icon>
      </center>
      <center>
        <!--v-img 
          class="icon" 
          src="https://hellosvg.com/wp-content/plugins/wpforms-lite/assets/images/submit-spin.svg" 
          style="margin: 20px 0 10px 0;height:50%;width:50%;"
        /-->
        <menu-icon
          :key="index"
          :image="item.icon"
          margin="0 0 10px 0"
          height="45%"
          width="45%"
        />
      </center>
      <center
        style="line-height:1;"
        :style="{ fontFamily: enterprise.Font }"
      >
      {{ getTranslation(item.name, locale) }}
        <external-link
          v-if="item.type === 'externalLink'"
          :item="item" 
          :locale="locale"
          :showDialog="showExternalLink"
          :onClose="handleCloseExternalLink"
          :bgColor="bgColor"
        />
      </center>
    </v-flex>
    <v-flex 
      v-if="menus.length < 6"
      v-bind="{ [`xs${(6-menus.length)*2}`]: true }"
      :style="{ backgroundColor: bgSecondaryColor }"
      :class="noShadow ? 'menu-item-no-shadow' : 'menu-item'"
    >
    </v-flex>







      </v-layout>
    </v-flex>
    <v-flex 
      xs1 
    >
      <center style="position:relative;padding: 20px 20px 20px 20px;">
        <v-img
          v-if="qrImage && qrImage.length > 0"
          :src="qrImage"
          :lazy-src="qrImage"
          aspect-ratio="1"
          class="grey lighten-2"
          width="80%"
          height="auto"
        />
      </center>
      <center style="position:relative;margin-top: -5px;font-size: 1rem;font-weight:700;line-height:1;">
        {{ getTranslation(qrInfo ? qrInfo : { es: 'VERSIÓN MÓVIL', en: 'MOBILE VERSION', de: 'MOBILE VERSION' }, locale) }}
      </center>
    </v-flex>
    <v-flex xs2
      >
      <center style="height: 70px;">
        <Meteo 
          v-if="enterprise"
          :meteoID="enterprise.MeteoID"
          :color="textColor"
          style="width:250px;"
        />
      </center>
      <center v-if="languages.length <= 3" style="font-size: 0.7rem;padding: 0 20px 0 0;">
        {{ getTranslation({ es: 'SELECTOR DE IDIOMA', en: 'LANGUAGE SELECTOR', de: 'SPRACHWECHSEL' }, locale) }}
      </center>
      <center style="padding: 0 20px 0 0"
        :style="{ marginTop:  languages.length > 3 ? '-5px' : '10px' }"
      >
      <v-btn
        v-for="item of languages"
        @click="handleChangeLocale(item)"
        :style="{ color: item === locale ? textColor: `${textColor.substring(0,7)}80` }"
        class="locale-item"
        text
        fab
        small
      >
      {{item.toUpperCase()}}
      </v-btn>
      </center>
    </v-flex>
  </v-layout>





  <v-layout 
    v-else-if="enterprise"
    wrap 
    style="height: 180px;fontFamily: MontserratRegular, sans-serif"
    :style="{
      backgroundColor: bgColor,
      color: textColor,
    }"
  >
    <v-flex 
      v-if="!enterprise.TotemMainMenuType || enterprise.TotemMainMenuType === 'right'"
      xs2 
    >
      <center style="position:relative;padding: 20px 20px 20px 20px;">
        <v-img
          v-if="qrImage && qrImage.length > 0"
          :src="qrImage"
          :lazy-src="qrImage"
          aspect-ratio="1"
          class="grey lighten-2"
          width="80%"
          height="auto"
        />
      </center>
      <center style="position:relative;margin-top: -5px;font-size: 1rem;line-height:1;font-weight:700;">
        {{ getTranslation(qrInfo ? qrInfo : { es: 'VERSIÓN MÓVIL', en: 'MOBILE VERSION', de: 'MOBILE VERSION' }, locale) }}
      </center>
    </v-flex>
    <v-flex xs2 :style="{ 'padding-left':  enterprise.TotemMainMenuType === 'between' ? '10px' : null}">
      <center style="height: 70px;">
        <Meteo 
          v-if="enterprise"
          :meteoID="enterprise.MeteoID"
          :color="textColor"
        />
      </center>
      <center style="font-size: 0.7rem;padding: 0 20px 0 0;" v-if="languages.length <= 3">
        {{ getTranslation({ es: 'SELECTOR DE IDIOMA', en: 'LANGUAGE SELECTOR', de: 'SPRACHWECHSEL' }, locale) }}
      </center>
      <center style="padding: 0 20px 0 0"
        :style="{ marginTop:  languages.length > 3 ? '-5px' : '10px' }"
      >
      <v-btn
        v-for="item of languages"
        @click="handleChangeLocale(item)"
        :style="{ color: item === locale ? textColor: `${textColor.substring(0,7)}80` }"
        class="locale-item"
        text
        fab
        small
      >
      {{item.toUpperCase()}}
      </v-btn>
      </center>
    </v-flex>
    <v-flex 
      xs2 
      v-for="(item, index) of menus"
      @click="handleClick(item.action, item, index)"
      :style="{ backgroundColor: bgSecondaryColor }"
      :class="enterprise.TotemMainMenuType === 'between' ? 'menu-item-between' : noShadow ? 'menu-item-no-shadow' : 'menu-item'"
      style="height: 100%"
    >
      <center 
        v-if="isInverted"
        style="height:40px"
      >
        <v-icon dark x-large
        v-if="activeMenu === item.action"
        >
          mdi-menu-up
        </v-icon>
      </center>
      <center>
        <!--v-img 
          class="icon" 
          src="https://hellosvg.com/wp-content/plugins/wpforms-lite/assets/images/submit-spin.svg" 
          style="margin: 20px 0 10px 0;height:50%;width:50%;"
        /-->
        <menu-icon 
          :image="item.icon"
          :margin="isInverted ? '0 0 10px 0' : '20px 0 10px 0'"
          :height="isInverted ? '45%' : '55%'"
          :width="isInverted ? '45%' : '55%'"
        />
        <!--v-img 
          class="icon" 
          :src="item.icon"
          :style="{ 
            margin: isInverted ? '0 0 10px 0' : '20px 0 10px 0',
            height: isInverted ? '45%' : '55%',
            width: isInverted ? '45%' : '55%'
          }"
        /-->
      </center>
      <center
        style="line-height:1;"
        :style="{ fontFamily: enterprise.Font }"
      >
      {{ getTranslation(item.name, locale) }}
        <!--external-link
          v-if="item.type === 'externalLink'"
          v-show="externalLinkIndex === index"
          :index="index"
          :selectedIndex="externalLinkIndex"
          :item="item" 
          :locale="locale"
          :showDialog="showExternalLink"
          :onClose="handleCloseExternalLink"
          :bgColor="bgColor"
        /-->
      </center>
      <center v-if="activeMenu === item.action && !isInverted">
        <v-icon dark x-large>mdi-menu-down</v-icon>
      </center>
    </v-flex>
    <v-flex 
      v-if="menus.length < 4"
      v-bind="{ [`xs${(4-menus.length)*2}`]: true }"
      :style="{ backgroundColor: bgSecondaryColor }"
      :class="noShadow ? 'menu-item-no-shadow' : 'menu-item'"
    >
    </v-flex>
    <v-flex 
      v-if="enterprise.TotemMainMenuType === 'between'"
      xs2 
    >
      <center style="position:relative;padding: 20px 20px 20px 20px;">
        <v-img
          v-if="qrImage && qrImage.length > 0"
          :src="qrImage"
          :lazy-src="qrImage"
          aspect-ratio="1"
          class="grey lighten-2"
          width="80%"
          height="auto"
        />
      </center>
      <center style="position:relative;margin-top: -5px;font-size: 1rem;line-height:1;font-weight: 700;">
        {{ getTranslation(qrInfo ? qrInfo : { es: 'VERSIÓN MÓVIL', en: 'MOBILE VERSION', de: 'MOBILE VERSION' }, locale) }}
      </center>
    </v-flex>

        <external-link
          v-if="selectedExternalLink"
          :item="selectedExternalLink" 
          :locale="locale"
          :showDialog="showExternalLink"
          :onClose="handleCloseExternalLink"
          :bgColor="bgColor"
        />
  </v-layout>
</template>
<script>
import QRCode from 'qrcode'
import utils from '@/services/utils'
import api from '@/services/api'
import statsService from '@/services/stats'
import Meteo from './Meteo'
import ExternalLink from './ExternalLink'
import axios from 'axios'
import MenuIcon from './MenuIcon'
export default {
  components: {
    Meteo,
    ExternalLink,
    MenuIcon,
  },
  props: {
    enterprise: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    isInverted: {
      type: Boolean,
      default: false,
    },
    noShadow: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    bgColor: null,
    textColor: null,
    bgSecondaryColor: null,
    textSecondaryColor: null,
    languages: [],
    menus: [],
    timeToGoToMain: 300,
    timer: null,
    activeMenu: null,
    qrImage: null,
    test: 0,
    selectedExternalLink: null,
    showExternalLink: false,
    externalLinkIndex: null,
    itemIcon: null,
  }),
  computed: {
    isDev () {
      return process.env.VUE_APP_ENV === 'development'
    },
    qrInfo () {
      return this.enterprise ? this.enterprise.TotemCustomURLInfo : null
    },
  },
  watch: {
    enterprise () {
      this.prepareConfig()
    },
    locale () {
      this.prepareIcon()
    },
  },
  created () {
    //this.startTimer()
    const that = this
    document.onclick = (event) => {
      // Compensate for IE<9's non-standard event model
      //
      if (event===undefined) event= window.event;
      var target= 'target' in event? event.target : event.srcElement;

      that.$store.state.app.totemLastClickTime = new Date()
    }
    /*
    window.addEventListener("keydown", e => {
      if (e.key === '1') that.handleClick('@webappbeach')
      else if (e.key === '2') that.handleClick('@barcelo')
      else if (e.key === '3') that.handleClick(':activity')
      else if (e.key === '4') that.handleClick(':meteo')
      else if (e.key === '0') that.goToHome()
      else that.handleReload()
    })*/
  },
  mounted () {
    this.startTimer()
    this.prepareConfig()
  },
  methods: {
    getTranslation (v, locale) {
      if (!v) return ''
      return utils.getTranslation(v, locale)
    },
    goToHome () {
      this.$store.state.app.totemDomain = null
      this.$store.state.app.totemActiveMenu = null
      this.$store.state.app.totemLastClickTime = null
      this.activeMenu = null
    },
    startTimer () {
      this.timer = window.setInterval(() => {
      //this.timer = setInterval(() => {
        this.checkUpdate()
        if (this.$store.state.app.totemLastClickTime) {
          const diff = (new Date() - this.$store.state.app.totemLastClickTime) /1000
          if (diff >= this.timeToGoToMain) {
            this.goToHome()
            /*
            this.$store.state.app.totemDomain = null
            this.$store.state.app.totemActiveMenu = null
            this.$store.state.app.totemLastClickTime = null
            this.activeMenu = null
            */
          }
        }

      }, this.timeToGoToMain * 1000)
    },
    stopTimer() {
      clearInterval(timer)
    },
    checkUpdate () {
      const domain = utils.getDomain()
      try {
        const url = `${process.env.VUE_APP_ENV === 'development' ? 'http://localhost:3803/' : 'https://cm-dtouch-api.dtouch.es/'}v1/public/system/totemLMD/${domain}`
        //const url = 'http://localhost:3803/v1/public/system/totemLMD'
        //const url = 'https://cm-dtouch-api.dtouch.es/v1/public/system/totemLMD'
        axios.get(url)
          .then (response => {
            if (response.data && this.$store.state.app.totemLMD < new Date(response.data)) {
              console.log('update')
              this.handleReload()
            } else {
              console.log('Nothing to update')
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    prepareMenu (v) {
      if (typeof v.image === 'string') 
        if (v.image.indexOf('{') == -1) v.image = { es: v.image}
        else v.image = JSON.parse(v.image)
      return v
    },
    async prepareConfig () {
      if (!this.enterprise) return 

      const url = this.enterprise.CustomURL && this.enterprise.CustomURL.length > 0 
        ? this.enterprise.CustomURL :
        `${window.location.protocol}//${window.location.host.split('www.').join('')}/#/`

      QRCode.toDataURL(url, {
        type: 'image/png',
        width: 344,
        margin: 0,
        color: {
          dark: this.enterprise.Color,  // Blue dots
          light: this.enterprise.BGColor
        }
      })
      .then(url => {
        this.qrImage = url
      })
      .catch(err => {
        console.error(err)
      })
      this.languages = this.enterprise.Languages.split(',')
      this.bgColor = this.enterprise.BGColor
      this.textColor = this.enterprise.Color
      this.bgSecondaryColor = this.enterprise.BGColorSecundary
      this.textSecondaryColor = this.enterprise.ColorSecundary

      // solve bug change domain menu
      if (this.enterprise.Menus && this.enterprise.Menus.length > 0) {
        for (let i = 0 ; i < this.enterprise.Menus.length ; i++) {
          if (this.enterprise.Menus[i].type && this.enterprise.Menus[i].type === 'domain') {
            this.enterprise.Menus[i].action = await new Promise((resolve) => api.getItem('enterprises', false, this.enterprise.Menus[i].domain).then(response => {
              if (response && response.Domain) resolve(`@${response.Domain}`)
              else resolve(this.enterprise.Menus[i].action)
            }))
          }
        }
      }
      // solve bug change domain menu
      this.menus = this.enterprise.Menus ? this.enterprise.Menus.filter(x => x.type).map(item => this.prepareMenu(item)) :
            [{
              name: { es: this.enterprise.Domain.toUpperCase() },
              action: `@${this.enterprise.Domain}`
            }, 
            {
              name: { es: ''},
              action: null
            },
            {
              name: { es: ''},
              action: null
            },
            {
              name: { es: ''},
              action: null
            },
            ]

      this.prepareIcon()
    },
    prepareIcon () {
        this.menus = this.menus.map(item => {
          item.icon = utils.getTranslation(item.image, this.locale)
          return item
        })
    },
    handleReload () {
      location.reload()
    },
    handleChangeLocale (v) {
        this.$store.state.app.locale = v
    },
    handleClick (action, item, index) {
      statsService.addStat({ WorkspaceID: this.enterprise.ID, MenuID: `mainMenu${index}`, Locale: this.locale })

      this.$store.state.app.totemItemImage = item.itemImage
      this.$store.state.app.totemItemImageTranslate = item.itemImageTranslate
      this.$store.state.app.totemItemPDF = item.itemPDF
      this.$store.state.app.totemItemBookingWorkspaceID = item.bookingWorkspaceID
      this.$store.state.app.totemItemBookingCategoryFilter = item.bookingCategoryFilter

      if (action.indexOf('activityBarcelo') >= 0) {
        action = `:activityBarcelo${item.dviewDviewcontentID}`
      } else if (action.indexOf('ç') === 0) {
        this.$store.state.app.totemIframeURL = JSON.parse(action.split('ç').pop())
      } else if (action.indexOf('#') === 0) {
        this.selectedExternalLink = item
        this.showExternalLink = true
        this.externalLinkIndex = index
      } else if (action.indexOf('@') === 0) {
        this.$store.state.app.totemDomain = action.split('@').pop()
        this.$store.state.app.totemBackDomain = null //hide back button
        this.$store.state.app.dtouchWorkspace = this.$store.state.app.totemDomain
      } else {
        this.$store.state.app.totemDomain = null
        this.$store.state.app.dtouchWorkspace = this.enterprise.ID
      }
      this.$store.state.app.totemActiveMenu = `${action}`
      this.$store.state.app.totemActiveMenuItem = item
      this.activeMenu = `${action}`
      this.$store.state.app.totemLastClickTime = new Date()
    },
    handleCloseExternalLink () {
      this.externalLinkIndex = null
      this.showExternalLink = false
      this.selectedExternalLink = null
      this.goToHome()
    },
  },
}
</script>
<style scoped>
.menu-item {
  text-align: center;
  color: white;    
  -webkit-box-shadow: 10px 0px 5px -2px #888;
  box-shadow: inset 10px 0px 10px #00000033;
}

.menu-item-no-shadow {
  text-align: center;
  color: white;    
}

.menu-item-between {
  text-align: center;
  color: white;    
}
.filter {
  filter: red;
}
.locale-item {
  padding: 0 !important;
  font-size:0.9rem;
  text-align: center;
  font-family: 'Roboto';
  margin: 0 2px;
  background-color: #0000001A;
}
</style>

